import React from "react";
import { Container } from "reactstrap";
import styled from "styled-components";
import PageComponents from "../PageComponents";

const ContainerStyled = styled(Container)`
  .page--components {
    .container {
      padding: 0px;

      &.component--text {
        ul {
        }
      }
    }
  }
`;

export default (props) => {
  var setStyle = {};
if (props.style) {
  props.style.split(';').forEach(item => {
    var sty = item.split(':');
    const key = sty[0]?.trim().replace(/-([a-z])/g, g => g[1].toUpperCase());
    const value = sty[1]?.trim();
    if (key && value) {
      setStyle[key] = value;
    }
  });
}

  return (
// Instead of dynamic style object
    <ContainerStyled className={[`component--${props.name}`, props.class].join(' ')} style={setStyle} id={props.id}>
      {props.children &&
        <PageComponents components={props.children} />
      }
    </ContainerStyled>
  );
};
